// Cold Experience Brand Colors
export const colors = {
  // Primary Background
  primary: '#1A2F46',
  
  // Secondary Background (panels)
  secondary: '#223B56',
  
  // Text Colors
  text: {
    primary: '#FFFFFF',        // Ren vit för bästa kontrast
    secondary: '#E2E8F0',      // Mycket ljus grå
    muted: '#CBD5E1',          // Ljusare grå för mindre viktig text
  },
  
  // Accent Colors
  accent: {
    primary: '#285A82',     // Knapp/CTA mörkblå
    hover: '#3F7BA7',       // Accent hover/light highlight
  },
  
  // UI Elements
  border: '#2C415C',        // Divider/lines
  
  // Gradients
  gradients: {
    hero: 'radial-gradient(circle at 50% 40%, rgba(10, 21, 35, 0.55) 0%, rgba(10, 21, 35, 0.05) 55%, rgba(10, 21, 35, 0) 70%), linear-gradient(180deg, rgba(26, 47, 70, 0.88) 0%, rgba(34, 59, 86, 0.78) 100%)',
    heroSolid: 'linear-gradient(180deg, #1A2F46 0%, #223B56 100%)',
    cardGlass: 'rgba(34, 59, 86, 0.3)',
  },
  
  // Glass/Blur effects
  glass: {
    light: 'rgba(234, 242, 250, 0.1)',
    medium: 'rgba(234, 242, 250, 0.15)',
    dark: 'rgba(26, 47, 70, 0.3)',
  }
};

// CSS Custom Properties för Tailwind
export const cssVariables = {
  '--color-primary': '#1A2F46',
  '--color-secondary': '#223B56',
  '--color-text-primary': '#EAF2FA',
  '--color-text-secondary': '#C6D4E4',
  '--color-accent-primary': '#285A82',
  '--color-accent-hover': '#3F7BA7',
  '--color-border': '#2C415C',
};
